import { BasePage } from '@/components/ui/base-page'

export function TroppaPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add TroppaPage specific content here */}
    </BasePage>
  )
}